import { withInstall } from '@hd-front-end/utils'
import ImageViewer from './src/image-viewer.vue'

import type { SFCWithInstall } from '@hd-front-end/utils'

export const ElImageViewer: SFCWithInstall<typeof ImageViewer> =
  withInstall(ImageViewer)
export default ElImageViewer

export * from './src/image-viewer'
